import CityPageTemplate from "../city-template/CityPageTemplate";
import { alexandriaVaConfig } from "./data";

export default function AlexandriaVaPage() {
  return <CityPageTemplate config={alexandriaVaConfig} />;
}